import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { media, helperTypographyTitle, TypographyTitleProps } from '@utex/ui-kit';

interface TitleProps {
  size?: TypographyTitleProps['size'];
}

export const HeaderContainer = styled('div')`
  height: 9.1rem;

  @media ${media.phonablet} {
    height: 5.8rem;
    margin-bottom: 1.7rem;
  }
`;

export const mainContent = css`
  flex-grow: 1;
`;

export const Wrapper = styled('div')`
  width: 100%;
  max-width: 100rem;
  margin: 0 auto;
  padding: 0 4rem;

  @media ${media.phonablet} {
    padding: 0 1rem;
  }
`;

export const Title = styled('h1')<TitleProps>`
  text-align: center;
  ${props => helperTypographyTitle({ size: props.size || { all: 'XXXL', phonablet: 'XXL' } })};
`;
